import React from 'react';
import { motion } from 'framer-motion';
import { bonuses } from '../data/volumes';
export function Bonuses() {
  return <section aria-labelledby="bonuses-title" className="bg-canvas" data-id="element-19" data-mp="pio9qp8e98a4">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" style={{
      paddingTop: "23px",
      paddingBottom: "13px"
    }} data-id="element-20" data-mp="avld0krwb3nu">
        <div className="text-center" data-id="element-21" data-mp="ft4pbf5196d5">
          <h2 id="bonuses-title" className="font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-22" data-mp="fs3dh8g70fud">
            Plus 5 professional bonuses
          </h2>
          <p className="mt-3 text-base text-muted" data-id="element-23" data-mp="5w8mnq1tfegi">Included with your access</p>
        </div>

        <div className="mt-12 space-y-5" data-id="element-24" data-mp="3o2eow0fp6p5a">
          {bonuses.map((b, i) => <motion.article key={b.n} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.25,
          delay: i % 2 * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col gap-5 rounded-2xl bg-white p-5 shadow-[0_14px_36px_-22px_rgba(11,31,51,0.35)] sm:flex-row sm:gap-8 sm:p-7" data-id="element-25" data-mp="3t0okgc5c3rrf" data-mpi={i}>
              <img src={b.cover} alt={`${b.title} — Bonus #${b.n} cover`} width={1122} height={1402} loading="lazy" decoding="async" sizes="160px" className="mx-auto h-auto w-32 shrink-0 self-start rounded-md object-contain shadow-[0_12px_24px_-10px_rgba(11,31,51,0.45)] sm:mx-0 sm:w-40" data-id="element-26" data-mp="3dg4zmynvy6l9" />
              <div className="min-w-0 flex-1" data-id="element-27" data-mp="2zf28w8ly4840">
                <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-28" data-mp="2zfu7lsaualyi">
                  <span className="text-xs font-bold uppercase tracking-[0.16em] text-gold-ink" data-id="element-29" data-mp="2uhsleyi4a6it">Bonus #{b.n}</span>
                  <span className="text-sm font-semibold" data-id="element-30" data-mp="38hjz0y4q1kwa">
                    <span className="text-muted line-through" data-id="element-31" data-mp="33gw6g80ugvzy">{b.value}</span>{' '}
                    <span className="text-success" data-id="element-32" data-mp="nprn5h4g75pd">Free</span>
                  </span>
                </div>
                <h3 className="mt-2 font-display text-xl font-black text-ink" data-id="element-33" data-mp="irgayzqokj3z">{b.title}</h3>
                <p className="mt-1 text-[15px] font-semibold text-ocean" data-id="element-34" data-mp="3cjfy7bd4mnie">{b.subtitle}</p>
                {b.body.map(p => <p key={p} className="mt-3 text-sm leading-relaxed text-muted" data-id="element-35" data-mp="3hhhq8lsj5x60">
                    {p}
                  </p>)}
                {b.tags && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-36" data-mp="3lk4cm76fmpvt">
                    {b.tags.map(t => <li key={t} className="rounded-full border border-line bg-canvas px-3 py-1 text-xs font-medium text-ink" data-id="element-37" data-mp="3qhmp27jnrn8k">
                        {t}
                      </li>)}
                  </ul>}
                {b.closing && <p className="mt-4 text-sm font-semibold text-ink" data-id="element-38" data-mp="2xujqjfezfcib">{b.closing}</p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}